<template>
  <div id="house-add" class="sav-wrapper">
    <Topbar/>
		<div class="sav-container">
      <Header back="/new" title="Νέα ασφάλεια κατοικίας" category="house"/>
      <Add category="house" :id="id" :cardHeaders="houseHeaders" />
    </div>
  </div>
</template>

<script>
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import Add from './../Add.vue'
import houseHeaders from './../../../public/data/db.house-single-headers.json'

export default {
	props: ['id'],
    components: {
    Topbar,
    Header,
    Add
  },
  data() {
        return {
            houseHeaders: houseHeaders
        }
	}
}
</script>

<style lang="scss" scoped>
</style>
